<template>
  <div class="my-l">
    <div class="container">
      <div class="text-center">
        <BarText v-if="heading" class="fluid-3xl leading-tightest" :text="heading" tag="h2" />
      </div>
      <div class="lg:grid-cols-3 grid gap-12 mt-12">
        <LinkField
          v-for="(card, index) in exploreMoreCards"
          :key="index"
          class="relative"
          :tracking-name="card.textOverlay ? stripHtml(card.textOverlay) : card.alt ? card.alt : card.image[0].title"
          :index="index"
          :to="card.linkTarget[0] ? $localeRootPath(card.linkTarget[0].uri) : null"
        >
          <FixedAspect :ratio="1.25">
            <CldnImg
              v-if="card.image[0]"
              :src="card.image[0].url"
              sizes="100vw sm:100vw md:100vw lg:100vw xl:100vw 2xl:100vw"
              crop="fill"
              class="block w-full"
              :alt="card.alt ? card.alt : card.image[0].title"
            />
          </FixedAspect>
          <div class="absolute inset-x-0 bottom-0 px-6 pb-10">
            <BarText
              v-if="card.textOverlay"
              class="fluid-xl leading-tight font-medium"
              :text="card.textOverlay"
              tag="h3"
            />
          </div>
        </LinkField>
      </div>
    </div>
  </div>
</template>

<script>
import CldnImg from '@/components/CldnImg';
import FixedAspect from '@/components/common/FixedAspect';
import BarText from '@/components/BarText';
import LinkField from '@/components/common/LinkField';
import { stripHtml } from '@/utils/common';

export default defineNuxtComponent({
  components: {
    BarText,
    FixedAspect,
    CldnImg,
    LinkField,
  },
  props: {
    heading: {
      type: String,
      default: null,
    },
    /**
     * cards count is fixed to 3 in craft backend - possible values are empty array or array with three items
     */
    exploreMoreCards: {
      type: Array,
      default: () => [],
    },

    blockPosition: {
      type: Number,
      default: 0,
    },
  },

  methods: {
    stripHtml,
  },
});
</script>
